import List from '../common/list';

export const CollectionsSlice = ({ fields, className = '' }) => (
  <List items={fields} className={className} />
);
